import Rellax from 'rellax'

import withResponsive from '../hoc/withResponsive'

export default withResponsive({
  name: 'rellax',

  componentDidMount () {
    // eslint-disable-next-line
    new Rellax(this.el, this.props)
  },
})
